import { IMAGE, ImageDefinition, TEXT, TextDefinition } from '../../items';
import { ItemHelper } from './types';

/**
 * Breaks down one API Text item into an array of TEXT items
 * @param src The API Text item
 * @returns An array of TEXT items
 */
interface TextHelperOptions {
  fontSize?: string;
  centerTitle?: boolean; // when true, heading1 (title) will be centered
}

interface Heading1Values {
  value: string;
  fontSize?: string;
  variant: 'heading1';
  center?: boolean;
}

export const TextHelper: ItemHelper<
  'Text',
  Array<TextDefinition | ImageDefinition>,
  TextHelperOptions
> = (src, options, shouldShowSubtitle = true) => {
  const defs: Array<TextDefinition | ImageDefinition> = [];
  if (src.subtitle && shouldShowSubtitle) {
    defs.push({
      id: `${src.id}_subtitle`,
      position: src.position ?? undefined,
      start: src.appear || undefined,
      type: TEXT,
      values: {
        value: src.subtitle,
        fontSize: options?.fontSize,
        variant: 'sub_heading',
        icon: src?.icon
      },
      items: []
    } as TextDefinition);
  }

  if (src.title) {
    defs.push({
      id: `${src.id}_title`,
      position: src.position ?? undefined,
      start: src.appear || undefined,
      type: TEXT,
      values: {
        value: src.title,
        fontSize: options?.fontSize,
        variant: 'heading1',
        center: options?.centerTitle ? true : undefined
      } as Heading1Values,
      items: []
    });
  }

  if (src.body) {
    defs.push({
      id: `${src.id}_body`,
      position: src.position ?? undefined,
      start: src.appear || undefined,
      type: TEXT,
      values: {
        value: src.body,
        fontSize: options?.fontSize
      },
      items: []
    });
  }

  for (const p of src.pictures || []) {
    defs.push({
      id: p.id,
      type: IMAGE,
      values: {
        url: p.mediaUrl,
        alt: p.name
      }
    } as ImageDefinition);
  }

  return defs;
};

export const addTargetBlankToLinks = (html: string): string => {
  if (html) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    const links = doc?.querySelectorAll('a');

    links?.forEach(link => {
      link.setAttribute('target', '_blank');
    });

    return doc.body.innerHTML;
  }

  return html;
};

export const removeEmptyTags = (str: string): string => {
  const res = str.replace(/<(\w+)\b[^>]*>\s*<\/\1>/g, '');
  return res.replace('<p><p>', '<p>').replace('</p></p>', '</p>');
};
